import { Utils } from "@/plugins/utils"
import router from '@/router'
import Enums from '@/plugins/Enums'

export const getItemRequiredFields = (isManagement = false, getLabel = k => k) => [
	{ key: 'cv7codigo', label: getLabel('cv7codigo') },
	{ key: 'cv7desc',   label: getLabel('cv7desc') },
	{ key: 'cv7qtde',   label: getLabel('cv7qtde') },
	{ key: 'cv7unmed',  label: getLabel('cv7unmed') },
	...(isManagement ? [
		{ key: 'cv7tamanho', label: getLabel('cv7tamanho') },
		{ key: 'cv7cor',     label: getLabel('cv7cor') },
	] : []),
]

export default {
	namespaced: true,

	state: {
		xmlImportado: null,
		nfeData: null,
		formData: null,
		salesOperations: [],
		isManagement: false,
	},

	getters: {
		xmlImportado: state => state.xmlImportado,
		nfeData: state => state.nfeData,
		formData: state => state.formData,
		salesOperations: state => state.salesOperations,
		isManagement: state => state.isManagement,
	},

	mutations: {
		setIsManagement(state, value) {
			state.isManagement = value
		},
		setXmlImportado(state, value) {
			state.xmlImportado = value
		},
		setNfeData(state, value) {
			state.nfeData = value
		},
		setFormData(state, value) {
			state.formData = value
		},
		setSalesOperations(state, value) {
			state.salesOperations = value
		},
		reset(state) {
			state.xmlImportado = null
			state.nfeData = null
			state.formData = null
			state.isManagement = false
		},
		patchInvoice(state, fields) {
			if (state.nfeData && state.nfeData.invoice) {
				state.nfeData = {
					...state.nfeData,
					invoice: { ...state.nfeData.invoice, ...fields },
				}
			}
		},
		patchItem(state, { index, fields }) {
			if (!state.nfeData?.items) return
			const items = [...state.nfeData.items]
			items[index] = { ...items[index], ...fields }
			state.nfeData = { ...state.nfeData, items }
		},
	},

	actions: {
		reset({ commit }) {
			commit('reset')
		},
		async findBusinessOperation({ commit, dispatch }, params) {
			const cv5opercom = typeof params === "object" ? params.cv5opercom : params
			const payload = typeof params === "object" ? params.payload : null
			if (!cv5opercom) return
			try {
				const response = await this._vm.$axios.get(`/Oryx/BusinessOperation/Find/${cv5opercom}`)
				const cv3 = Utils.ValidateAxiosResponse(response.data)
				if (!cv3) return

				commit("patchInvoice", {
					cv5operdes: cv3.cv3nome ?? ""
				})

				const validationPayload = payload ? {
					...payload,
					invoice: {
						...payload.invoice,
						cv5operdes: cv3.cv3nome ?? ""
					},
				} : null

				return await dispatch('validOpercom', validationPayload)
			} catch (error) {
				dispatch(
					"parameters/openDialog",
					{ titleText: "Erro", titleColor: "red", text: error.message },
					{ root: true }
				)
			}
		},
		async validOpercom({ commit, dispatch, state }, payload = null) {
			try {
				const requestPayload = payload ?? {
					...state.nfeData,
					invoice: {
						...state.nfeData.invoice,
						...state.formData,
					},
				}

				const response = await this._vm.$axios.post(`/Financial/XmlNFE/ValidOpercom`, requestPayload)

				const data = Utils.ValidateAxiosResponse(response.data)


				if (!data) return false

				data.invoice.cv5emissor = payload.invoice.cv5emissor
				data.invoice.cv5emisnom = payload.invoice.cv5emisnom

				commit("setNfeData", data)

				return data
			} catch (error) {
				dispatch(
					"parameters/openDialog",
					{ titleText: "Erro", titleColor: "red", text: error.message },
					{ root: true }
				)
				return false
			}
		},
		async findSalesOperations({ commit, dispatch }) {
			try {
				const response = await this._vm.$axios.get("/OryxPdv/SalesOperationParameters/FindAll")
				const data = Utils.ValidateAxiosResponse(response.data)
				commit("setSalesOperations", data ?? [])
			} catch (error) {
				dispatch(
					"parameters/openDialog",
					{ titleText: "Erro", titleColor: "red", text: error.message },
					{ root: true }
				)
			}
		},

		async manifestNfe({ dispatch }, chave) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Realizando Manifesto", indeterminate: true }, { root: true })
			try {
				await this._vm.$axios.post(
					`/Financial/XmlNFE/ManifestarNFe?acessKey=${chave}`
				)

				return true

			} catch (error) {
				dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true }
				)

				return false
			} finally {
				dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			}
		},

		async downloadXml({ dispatch }, chave) {
			dispatch("parameters/openGlobalLoading", {
				showLoadingGlobal: true,
				text: "Fazendo Download",
				indeterminate: true
			}, { root: true })

			try {
				const response = await this._vm.$axios.get(
					`/Financial/XmlNFE/DownloadXmlByAcessKey?acessKey=${chave}`,
					{ responseType: "blob" }
				)

				const blob = new Blob([response.data], { type: "application/xml" })
				const link = document.createElement("a")

				link.href = window.URL.createObjectURL(blob)
				link.download = `${chave}-procNFe.xml`
				link.click()

				dispatch("parameters/openDialog", {
					titleText: "Sucesso",
					titleColor: "green",
					text: "XML baixado com sucesso! Confira na aba de downloads."
				}, { root: true })

				return { success: true }

			} catch (error) {
				if (error.response) {
					try {
						const text = await error.response.data.text()
						const json = JSON.parse(text)

						if (error.response.status === 409) {
							return json
						}

						dispatch("parameters/openDialog", {
							titleText: "Erro",
							titleColor: "red",
							text: json.mensagem
						}, { root: true })

						return false

					} catch {
						dispatch("parameters/openDialog", {
							titleText: "Erro",
							titleColor: "red",
							text: "Erro inesperado"
						}, { root: true })

						return false
					}
				}

				throw error
			} finally {
				dispatch("parameters/openGlobalLoading", {
					showLoadingGlobal: false,
					text: ""
				}, { root: true })
			}
		},

		async importXml({ commit, dispatch, rootGetters }, xml ) {

			const lxd = rootGetters['lxd/getLxd']
			commit('setIsManagement', lxd?.lxdmodulo === Enums.OryxModulesType.ORYX_GESTAO)
			
			dispatch("parameters/openGlobalLoading", {
				showLoadingGlobal: true,
				text: "Enviando",
				indeterminate: true
			}, { root: true })

			let data = null

			try {
				const formData = new FormData()
				formData.append("xml", xml) 

				const response = await this._vm.$axios.post(
					"/Financial/XmlNFE/ImportNFEXml",
					formData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
						},
					}
				)

				data = Utils.ValidateAxiosResponse(response.data)

				commit("setXmlImportado", data)
				commit("setNfeData", data)
				commit("setFormData", {
					cv5opercom: data.invoice.cv5opercom,
					cv5descfat: data.invoice.cv5descfat,
					cv5dhsaida: data.invoice.cv5dhsaida && !data.invoice.cv5dhsaida.startsWith("0001-01-01")
						? data.invoice.cv5dhsaida.slice(0, 16)
						: (() => { const now = new Date(); return new Date(now - now.getTimezoneOffset() * 60000).toISOString().slice(0, 16) })(),
					cv5pedido: data.invoice.cv5pedido,
				})

			} catch (error) {

				dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true }
				)

				data = false
			}

			finally {
				dispatch("parameters/openGlobalLoading", {
					showLoadingGlobal: false,
					text: ""
				}, { root: true })
			}

			return data
		},

		async saveForm({ dispatch, state }, payload) {
			let result = false

			if(payload.invoice.cv5descfat) {
				const descFatDiff = parseFloat(state.nfeData.invoice.cv5totalnf) - parseFloat(payload.invoice.cv5descfat)

				result = await new Promise((resolve) => {
					dispatch("parameters/openDialog", {
						titleText: "Atenção",
						titleColor: "orange",
						text: `A soma das parcelas difere do total da nota em R$ ${descFatDiff}. Deseja continuar?`,
						confirmBtn: true,
						confirmText: "Continuar",
						confirmAction: async () => {
							resolve(await dispatch("sendForm", payload))
						},
						cancelText: "Cancelar",
						cancelAction: () => resolve(false),
					}, { root: true })
				})
			} else {
				result = await dispatch("sendForm", payload)
			}

			return result
		},
		async sendForm({ dispatch, state }, payload) {
			let result = false

			dispatch("parameters/openGlobalLoading", {
				showLoadingGlobal: true,
				text: "Salvando",
				indeterminate: true
			}, { root: true })
			
			try {
				const response = await this._vm.$axios.post("/Financial/XmlNFE/Save", payload)
				Utils.ValidateAxiosResponse(response.data)

				dispatch("parameters/openDialog", {
					titleText: "Sucesso",
					titleColor: "green",
					text: "XML NFE salvo com sucesso!",
					confirmBtn: true,
					confirmText: "OK",
					cancelText: "Entrada de Materiais da nota",
					confirmAction: () => dispatch("reset"),
					cancelAction: () => {
						router.push(`/oryxpdv/recebimento-material/${state.nfeData.invoice.cv5doc}/${state.nfeData.invoice.cv5tipo}/${state.nfeData.invoice.cv5emissor}`)
					},
				}, { root: true })

				result = true
			} catch (error) {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			} finally {
				dispatch("parameters/openGlobalLoading", {
					showLoadingGlobal: false,
					text: ""
				}, { root: true })
			}

			return result
		}
	},
}
